<template>
  <span class="badge rounded-pill text-bg-light app"></span>
</template>